import { render, staticRenderFns } from "./MemberDetailMyLayout.vue?vue&type=template&id=5bc5138f&scoped=true&"
import script from "./MemberDetailMyLayout.vue?vue&type=script&lang=js&"
export * from "./MemberDetailMyLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc5138f",
  null
  
)

export default component.exports